import React from 'react'

const OpenIcon = ({Fill}:SVGProps) => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.4444 0V2.44444H17.8322L5.81778 14.4589L7.54111 16.1822L19.5556 4.16778V8.55556H22V0M19.5556 19.5556H2.44444V2.44444H11V0H2.44444C1.79614 0 1.17438 0.257539 0.715961 0.715961C0.257539 1.17438 0 1.79614 0 2.44444V19.5556C0 20.2039 0.257539 20.8256 0.715961 21.284C1.17438 21.7425 1.79614 22 2.44444 22H19.5556C20.2039 22 20.8256 21.7425 21.284 21.284C21.7425 20.8256 22 20.2039 22 19.5556V11H19.5556V19.5556Z" fill={Fill ? Fill :"white"}/>
    </svg>
    
  )
}

export default OpenIcon